import { gql } from "@apollo/client";

export const createInquiryForm = gql`
  mutation CreateInquiryForm($input: PageCreateInput!) {
    pageCreate(input: $input) {
      page {
        id
        title
        slug
        metadata {
          key
          value
        }
        pageType {
          name
          slug
        }
        isPublished
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const updateInquiryFormMetadata = gql`
  mutation UpdateInquiryFormMetadata($id: ID!, $input: [MetadataInput!]!) {
    updateMetadata(id: $id, input: $input) {
      item {
        metadata {
          key
          value
        }
        ... on Node {
          id
        }
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const updateInquiryForm = gql`
  mutation UpdateInquiryForm($id: ID!, $input: PageInput!) {
    pageUpdate(id: $id, input: $input) {
      page {
        id
        title
        slug
        isPublished
      }
      errors {
        field
        message
        code
      }
    }
  }
`;

export const deleteInquiryForm = gql`
  mutation DeleteInquiryForm($id: ID!) {
    pageDelete(id: $id) {
      page {
        id
        title
        slug
      }
      errors {
        field
        message
        code
      }
    }
  }
`;